

import React, { useEffect, useState } from "react";
import { Box, Button, Typography, Container, Stack } from "@mui/material";
import home_page_Image from "../../../../../Assets/stakenow_home_image.png";
import { adminUrl } from "../../../../../constants";
import actions from "../../../../../ReduxStore/actions";
import { useDispatch, useSelector } from "react-redux";
import ModalApproveButton from "../../../../../Components/ModalButton/HomeSectionButton/ModalApproveButton";

const StakeNowMainPage = ({ bannerDates, values, sectionNameForApproveAndReject, onClose }) => {





    const [responseData, setResponseData] = useState()

    console.log(values, "valuesssss")
    console.log(responseData, "responseDatattaatatatt")
    const TableId = useSelector((state) => state.Table.TableId);

    console.log(TableId, "TebleIddddd")

    const dispatch = useDispatch()

    useEffect(() => {
        console.log(TableId, "TebleIddddd111")

        if (TableId && !values) {
            console.log(TableId, "TebleIddddd222")

            const fetchData = async () => {
                const data1 = {
                    data: {},
                    method: "get",
                    apiName: `getStakeNowSectionById/${TableId}`,
                };
                const response = await dispatch(actions.GETSTAKENOWSECTIONBYID(data1));

                console.log(response, "responseresponse")

                if (response?.payload?.message === "Stake Now section retrieved successfully.") {
                    console.log("hiiii")

                    setResponseData(response?.payload?.data)
                    // setUploadedFile({
                    //     fileUrl: response?.payload?.data.additional_data[0]?.banner,
                    //     type: "img",
                    //     progress: 100,
                    // }
                    // )
                    // console.log(response?.payload?.data.additional_data[0]?.banner,"yhfuwrfrkjrw")
                }
            };
            fetchData();
        }

    }, []);

    return (
        <Box>
            <Box
                sx={{
                    position: "relative", // Needed for positioning child elements
                    background: `linear-gradient(90deg, #000000 0%, #54545400 100%), url(${adminUrl}${responseData?.additional_data[0]?.banner || values?.image})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    overflow: "hidden",
                    padding: "90px 0px",
                    // left:"100px"
                    // minHeight: "90vh", // Adjust height as needed
                }}
            >
                <Container maxWidth="lg" sx={{ zIndex: 2 }}>
                    <Box
                        display="flex"
                        // alignItems="center"
                        justifyContent="start"
                        flexWrap="wrap"
                    >
                        {/* Left Section */}
                        <Box
                            sx={{

                                color: "#fff",
                            }}
                        >
                            <Typography
                                variant="h1"
                                textAlign="start"

                            >
                                {responseData?.heading || values?.title}
                            </Typography>
                            <Typography
                                variant="h2"
                                textAlign="start"
                                sx={{

                                    mb: 2,
                                }}
                            >
                                {responseData?.sub_heading || values?.subtitle}
                            </Typography>
                            <Typography
                                variant="body1"
                                textAlign="start"
                                sx={{
                                    mb: 5,
                                    lineHeight: "1.6",
                                    color: "#ffffff",
                                    // width:"55%",
                                    maxWidth: "500px",

                                    letterSpacing: "0px",
                                    color: "#b0aaaa",
                                    opacity: 1
                                }}
                            >
                                {responseData?.content || values?.content}
                            </Typography>
                            <Stack spacing={2} direction="row">
                                <Button
                                    variant="contained"
                                    // onClick={onScrollToTarget}

                                    sx={{
                                        // backgroundColor: "#C38F51",
                                        textTransform: "none",
                                        color: "white",

                                        // padding: "0px 40px",
                                        padding: { xs: "0px 20px", md: "0px 40px" },

                                        minHeight: "40px",
                                        borderRadius: "23px",
                                        background: "#C38F51 0% 0% no-repeat padding-box",
                                        "&:hover": {
                                            backgroundColor: "#C38F51",
                                        },
                                    }}
                                >
                                    {responseData?.additional_data?.[0]?.primary_button_text || values?.primary_button_text}
                                </Button>

                            </Stack>
                        </Box>
                    </Box>
                </Container >
            </Box >
            <ModalApproveButton approveStatus={responseData?.approval_status} values={values} onClose={onClose} sectionNameForApproveAndReject={sectionNameForApproveAndReject}/>
        </Box>
    );
};

export default StakeNowMainPage;
